import {useEffect} from 'react';
import axios from 'axios';
import {isDefined} from './services/SecondaryMethods/typeUtils';
import {getApplicationLang} from './services/SecondaryMethods/userSettings';

export interface Props {
  signOut: () => void;
}

const useInitAxios = ({signOut}: Props) => {
  useEffect(() => {
    axios.interceptors.request.use(
      function (config) {
        if (config.method === 'post' && config.data) {
          try {
            if (!isDefined(config.data.Language)) {
              config.data.Language = getApplicationLang();
            }

            if (config.url === '/wapi/Sys_Forms/List') {
              if (!isDefined(config.data.Params)) {
                config.data.Params = {};
              }

              config.data.Params = {...config.data.Params, IsUI: 1};
            }
          } catch (e) {}
        }

        // Do something before request is sent
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(response => {
      if (response.data.ResponseCode === '401') {
        signOut();
      }
      return response;
    });
  }, []);
};

export default useInitAxios;
